/**
 * Teacher profile photos live in yoga-frontend/public/images/.
 * After build/deploy they are served at /images/<filename>.
 * Instructor-uploaded photos may be absolute https:// URLs or data: URLs.
 */
const PUBLIC_IMAGES_BASE = "/images";

const TEACHER_IMAGE_FILES = {
  "g-tyagi": "t_gtyagi.jpg",
  "kritika-sharma": "t_kritika.jpg",
  T001: "t_gtyagi.jpg",
  T002: "t_kritika.jpg",
};

const TEACHER_IMAGES_BY_SLUG = Object.fromEntries(
  Object.entries(TEACHER_IMAGE_FILES)
    .filter(([key]) => key.includes("-"))
    .map(([slug, file]) => [slug, `${PUBLIC_IMAGES_BASE}/${file}`])
);

const TEACHER_IMAGES_BY_ID = Object.fromEntries(
  Object.entries(TEACHER_IMAGE_FILES)
    .filter(([key]) => key.startsWith("T"))
    .map(([id, file]) => [id, `${PUBLIC_IMAGES_BASE}/${file}`])
);

const LEGACY_PROFILE_IMAGES = {
  "t_kritika.avif": `${PUBLIC_IMAGES_BASE}/t_kritika.jpg`,
  "images/t_kritika.avif": `${PUBLIC_IMAGES_BASE}/t_kritika.jpg`,
};

function isAbsoluteOrDataUrl(value) {
  const v = String(value || "").trim();
  return (
    /^https?:\/\//i.test(v) ||
    /^data:image\//i.test(v) ||
    /^blob:/i.test(v)
  );
}

function publicImagePath(filename) {
  const raw = String(filename || "").trim().replace(/^\/+/, "");
  if (!raw) return "";
  return raw.startsWith("images/") ? `/${raw}` : `${PUBLIC_IMAGES_BASE}/${raw}`;
}

function normalizeImagePath(value) {
  if (!value) return "";
  const trimmed = String(value).trim();
  if (!trimmed) return "";

  // Uploaded instructor photos / CDN / data URLs — use as-is
  if (isAbsoluteOrDataUrl(trimmed)) {
    return trimmed;
  }

  const raw = trimmed.replace(/^\/+/, "");
  if (LEGACY_PROFILE_IMAGES[raw]) {
    return LEGACY_PROFILE_IMAGES[raw];
  }

  return publicImagePath(raw);
}

export function getTeacherImage({
  instructor_slug: instructorSlug,
  teacher_slug: teacherSlug,
  teacher_id: teacherId,
  profile_image: profileImage,
} = {}) {
  // Prefer an explicit uploaded/CDN photo over hardcoded slug maps
  const fromProfile = normalizeImagePath(profileImage);
  if (fromProfile && isAbsoluteOrDataUrl(fromProfile)) {
    return fromProfile;
  }

  const slug = instructorSlug || teacherSlug;
  if (slug && TEACHER_IMAGES_BY_SLUG[slug]) {
    return TEACHER_IMAGES_BY_SLUG[slug];
  }

  if (teacherId && TEACHER_IMAGES_BY_ID[String(teacherId).trim()]) {
    return TEACHER_IMAGES_BY_ID[String(teacherId).trim()];
  }

  if (fromProfile) return fromProfile;

  return `${PUBLIC_IMAGES_BASE}/nalanda.jpg`;
}

export function isTeacherListingItem(item) {
  return item?.item_source === "teacher_offering" || item?.source === "yoga_teachers";
}

export { TEACHER_IMAGE_FILES, PUBLIC_IMAGES_BASE, normalizeImagePath, isAbsoluteOrDataUrl };
